import React from 'react'
import './card.css'
import Aos from 'aos'
import 'aos/dist/aos.css'

Aos.init();

export default function Card(props) {
    return (
        <div id="card">
            <div data-aos="fade-up" data-aos-easing="ease-out-cubic"
                data-aos-duration="500" className="container-fluid d-flex align-items-md-center h-100">
                <div className="row h-100">
                    <div className="col-3 col-md-12 img-area-card">
                        <div className="safari-center h-100">
                            <img  src={props.img} alt={props.titulo} />
                        </div>
                    </div>
                    <div className="col-9 col-md-12 text-md-center text-area-card d-flex align-items-center align-items-md-start">
                        <div>
                            <label className="tituloCard mt-2 mb-md-3 mb-1">{props.titulo}</label>
                            <label className="textCard mb-md-5">{props.text}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
